export enum EExtraFieldNames {
  /**
   * Force render arrow icon in the explorer tree
   */
  ShowExpandArrow = 'showExpandArrow',
}
